import React, { useEffect } from "react";
import { Button, Divider, Tag } from "antd";
import { Check, MoreOutlined, Warning } from "assets/icons";
import { IProcessData } from "store/location/location-model";
import theme from "styles/theme";
import useTranslation from "utils/hooks/useTranslation";
import { IProcessActive } from "../../create-unit.service";
import * as S from "./styled/index.styled";

export interface IProcess {
  processList: Array<IProcessData>;
  processActive: IProcessActive[];
  updateProcessActive: (...args) => void;
  locationsConfigurationsUpdateConfigurationProcessActive: (...args) => void;
  locationsConfigurationsProcessShowDrawer: () => void;
}

const ProcessTabPane = ({
  processList,
  processActive,
  locationsConfigurationsUpdateConfigurationProcessActive,
  locationsConfigurationsProcessShowDrawer,
  updateProcessActive,
}: IProcess) => {
  const ACTIVE = useTranslation({ id: "active" });
  const INACTIVE = useTranslation({ id: "inactive" });

  useEffect(() => {
    updateProcessActive(processActive);
  }, []);

  const onChangeProcessConfiguration = (configuration) => {
    locationsConfigurationsUpdateConfigurationProcessActive(configuration);
    locationsConfigurationsProcessShowDrawer();
  };

  return (
    <div style={{ marginTop: "20px" }}>
      {processList?.length > 0 &&
        processList?.map((configuration) => (
          <>
            <S.ConfigurationsContainer key={configuration.id}>
              <S.DescriptionConfiguration>{configuration.description}</S.DescriptionConfiguration>
              <Tag
                className="icon"
                style={{ color: configuration.active ? theme["@color-positive-600"] : theme["@color-warning-600"] }}
                icon={configuration.active ? <Check /> : <Warning />}
                color={configuration.active ? theme["@color-positive-100"] : theme["@color-warning-100"]}
              >
                {configuration.active ? ACTIVE : INACTIVE}
              </Tag>
              <S.ActionContainer>
                <Button
                  type="text"
                  shape="circle"
                  icon={<MoreOutlined className="hoverActionButton" />}
                  className="actionButton"
                  data-testid={`moreOptions-${configuration?.description}`}
                  onClick={() => onChangeProcessConfiguration(configuration)}
                />
              </S.ActionContainer>
            </S.ConfigurationsContainer>
            <Divider />
          </>
        ))}
    </div>
  );
};

export default ProcessTabPane;
